
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import OnlinePayments from './OnlinePayments';

function OnlinePaymentsMain() {
    useEffect(() => {
        document.title = "Online Payments | InvoicePoint"
   }, []);
   const[loader, SetLoader] = useState(false)
    useEffect(() =>
    setTimeout(() =>{
        SetLoader(true)
    },1500)[loader]  
    )
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <OnlinePayments/>
            <Footer/>
        </Fragment>
    )
    
}

export default OnlinePaymentsMain;